export enum ServiceVehicleFormMode {
  NEW = 'new',
  EDIT = 'edit',
  CLONE = 'clone',
  NEW_FROM_SALE = 'newFromSale',
}
